// bars animate when the row scrolls into view
(function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.track').forEach(function (el) { io.observe(el); });

  // obscurity mode toggle
  var toggle = document.querySelector('[data-obs-toggle]');
  if (toggle) {
    var listOn = document.querySelector('[data-obs-list="on"]');
    var listOff = document.querySelector('[data-obs-list="off"]');
    toggle.addEventListener('click', function () {
      var on = !toggle.classList.contains('is-on');
      toggle.classList.toggle('is-on', on);
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      if (listOn) listOn.hidden = !on;
      if (listOff) listOff.hidden = on;
    });
  }

  // mobile nav
  var burger = document.querySelector('.header__burger');
  var mobile = document.querySelector('.header__mobile');
  if (burger && mobile) {
    burger.addEventListener('click', function () {
      var open = mobile.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // cookie bar
  var bar = document.getElementById('cookieBar');
  if (bar) {
    try {
      if (!localStorage.getItem('sb_consent')) bar.hidden = false;
    } catch (err) { /* storage blocked */ }
    bar.querySelectorAll('[data-consent]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        try { localStorage.setItem('sb_consent', btn.dataset.consent); } catch (err) {}
        bar.hidden = true;
      });
    });
  }

  // hero search → hand the query to the app
  document.querySelectorAll('[data-app-search]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var base = form.dataset.appSearch;
      if (!base) return;
      var q = form.querySelector('input').value.trim();
      window.location.href = base + (q ? '?q=' + encodeURIComponent(q) : '');
    });
  });
})();
